import injectResource from '../inject';
import setupReducer from '../helpers/setup-reducer';
import receiveEntities from './receive-entities';
import getDescriptorFromConnectArgs from './get-descriptor';
import createActions from './create-actions';
import createReducer from './create-reducer';

export default (Schema, Entity, customProperties = {}) => {
  const Actions = createActions(Schema);
  const resourceKeyName = Schema.name.toLowerCase();

  setupReducer(Actions, Schema, createReducer);

  return {
    Actions,
    Schema,

    connect(...args) {
      const descriptor = getDescriptorFromConnectArgs(args);

      if (!descriptor) {
        throw new Error(`@connect ${Schema.name}: invalid arguments`);
      }

      return TargetComponent =>
        injectResource(TargetComponent, Schema, this, descriptor, resourceKeyName);
    },

    provide(target, ...descriptor) {
      const withResource = this.connect(...descriptor);
      return withResource(target);
    },

    read(id, options) {
      return dispatch => {
        const key = `${resourceKeyName}/read`;
        const operation = this.runOperation(key, id, id, options);

        return dispatch(operation).then(result => {
          dispatch(Actions.insert(id, result.value));
          return dispatch(receiveEntities(Entity, result.value));
        });
      };
    },

    prepend(id, entities) {
      return dispatch => {
        return dispatch(Actions.prepend(id, entities));
      };
    },

    append(id, entities) {
      return dispatch => {
        return dispatch(Actions.append(id, entities));
      };
    },

    remove(id, entities) {
      return dispatch => {
        return dispatch(Actions.remove(id, entities));
      };
    },

    ...customProperties,
  };
};
